import React from 'react';

type EstimationConfig = {
  claims: number;
  time: number;
  unit: 'seconds' | 'minute' | 'minutes';
};

const estimationItems: EstimationConfig[] = [
  {
    claims: 1,
    time: 30,
    unit: 'seconds',
  },
  {
    claims: 5,
    time: 1,
    unit: 'minute',
  },
  {
    claims: 10,
    time: 2,
    unit: 'minutes',
  },
];

type EstimationItemProps = EstimationConfig;

function EstimationItem({ claims, time, unit }: EstimationItemProps) {
  const claimsLabel = claims === 1 ? '1 claim' : `${claims} claims`;

  return (
    <div className="flex flex-col justify-between text-gray-500">
      <span className="font-medium text-gray-500">
        {claimsLabel}
      </span>
      <span className="font-medium text-gray-700">
        ~
        {time}
        {' '}
        {unit}
      </span>
    </div>
  );
}

export default function EOBScanEstimation() {
  return (
    <div className="flex flex-col gap-0.5">
      <div className="mb-1.5 text-xs font-semibold text-gray-700">
        Estimated scan time
      </div>
      <div className="flex justify-between gap-0.5 text-xs">
        {estimationItems.map((item) => (
          <EstimationItem
            key={item.claims}
            {...item}
          />
        ))}
      </div>
    </div>
  );
}
